var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330",
    transform: "translate(-5643.968 -7360.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    transform: "translate(5643.968 7360.742)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5,
    cy: 25,
    rx: 25.5,
    ry: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5,
    cy: 25,
    rx: 24,
    ry: 23.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288",
    transform: "translate(5670.05 7371.101)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_421",
    "data-name": "Line 421",
    y2: 15,
    transform: "translate(-0.083 -0.358)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_422",
    "data-name": "Line 422",
    x1: 8,
    y1: 7,
    transform: "translate(-0.083 14.642)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.c77b10195710c1aeb231a16eab600136.svg";
export { ForwardRef as ReactComponent };